/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * TSOA-friendly assignment strategy used by the MeLi sync endpoint.
 */
export type MeliItemSyncImportAssignmentKeep = {
    /**
     * Assignment mode.
     */
    mode: MeliItemSyncImportAssignmentKeep.mode;
};
export namespace MeliItemSyncImportAssignmentKeep {
    /**
     * Assignment mode.
     */
    export enum mode {
        KEEP = 'keep',
    }
}

